exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".App__appIntro___3Wl-- {\n  font-size: large;\n}\n.App__enter___2b1lY {\n  opacity: 0;\n}\n.App__enterActive___dwIcL {\n  opacity: 1;\n  transition: 700ms;\n}\n.App__leave___2MiIp {\n  opacity: 1;\n}\n.App__leave___2MiIp.App__leaveActive___okgLj {\n  opacity: 0;\n  transition: 700ms;\n}\n.App__epportEsaWrapper___W26q- {\n  text-align: left;\n  padding-left: 20%;\n}\n.App__epportEsaWrapper___W26q- h1 {\n  color: #000;\n  text-transform: lowercase;\n  margin-top: 0px;\n  font-size: 70px;\n  margin-bottom: 10px;\n  line-height: 60px;\n  font-weight: 700;\n}\n.App__thanks___3j9F6 {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n}\n", ""]);

// exports
exports.locals = {
	"appIntro": "App__appIntro___3Wl--",
	"enter": "App__enter___2b1lY",
	"enterActive": "App__enterActive___dwIcL",
	"leave": "App__leave___2MiIp",
	"leaveActive": "App__leaveActive___okgLj",
	"epportEsaWrapper": "App__epportEsaWrapper___W26q-",
	"thanks": "App__thanks___3j9F6"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./~/stylus-loader!./src/App.styl
// module id = 222
// module chunks = 0